export default __webpack_public_path__ + "static/too-many-ballot-measures-393a36335106bf88ae18a63079fa1222.jpg";